module.exports = __webpack_public_path__ + "media/entities/5103-8d94bcd4.png";